import axios from 'axios'
import { getToken } from './auth'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 15000,
  // headers: { 'Content-Type': 'application/json' },
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    if (getToken() && !config.url.includes('http')) {
      config.headers.Authorization = 'Bearer ' + getToken()
    }
    if (config.url.includes('http://jgapi.jugong365.com')) {
      if (config.method === 'post') {
        config.data = config.data + '&secret_key=zhEMczjafYxcuy9x6iAJ'
      } else if (config.method === 'get') {
        config.params = {
          secret_key: 'zhEMczjafYxcuy9x6iAJ',
          ...config.params,
        }
      }
    }

    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  },
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    console.log('err:' + error)

    return Promise.reject(error)
  },
)

export default service
